import { render } from "./EmptyList.vue?vue&type=template&id=9f067140&scoped=true"
import script from "./EmptyList.vue?vue&type=script&lang=js"
export * from "./EmptyList.vue?vue&type=script&lang=js"

import "./EmptyList.vue?vue&type=style&index=0&id=9f067140&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f067140"]])

export default __exports__